import React from 'react';
import PropTypes from 'prop-types';
import { uuidv4 } from '../../../utils/utility';
import { fileHandlerUrl } from '../../../utils/consts/server';
import { DeleteIcon } from '../../../content/svg-component';
const ImagePreview = ({
  images = [],
  size = 280,
  editable = false,
  onClick = () => {},
}) => {
  return (
    <div className="d-flex flex-wrap align-items-center overflow-auto h-max-image-grid-container">
      {images.map((item) => {
        const imageId = uuidv4();
        return (
          <div className="position-relative">
            <img
              width={size}
              height={size}
              key={imageId}
              alt="image"
              src={`${fileHandlerUrl}/file/show/${item}`}
              className="m-2 rounded"
            />
            {editable && (
              <span
                className="position-absolute bg-third-light p-1 rounded position-image-delete-icon cursor-pointer"
                onClick={() => onClick(item)}
              >
                <DeleteIcon color="#dc2633" size={16} />
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
};

ImagePreview.propTypes = {
  images: PropTypes.array,
  size: PropTypes.string,
  editable: PropTypes.bool,
  onClick: PropTypes.func,
};

export default ImagePreview;
